import React, { useEffect, useState } from "react";
import { PulseDot, EqBars } from "@/components/cathedral/Primitives";
import TokenBadge from "@/components/cathedral/TokenBadge";
import { MemberBadge } from "@/components/cathedral/MemberAuth";

/**
 * TopBar · slim system status strip.
 * The 7-Pillar Master Menu ("WHITE CRISIS" fix, Architect mandate 2026-07)
 * now lives as a PURE STATIC layer in public/index.html (#nx-static-pillars)
 * so it renders in served HTML even if the SPA never hydrates.
 */
export default function TopBar({ codexVersion = "HumanCodex_NextXus_Cathedral_v5.1" }) {
  const [time, setTime] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const hh = String(time.getUTCHours()).padStart(2, "0");
  const mm = String(time.getUTCMinutes()).padStart(2, "0");
  const ss = String(time.getUTCSeconds()).padStart(2, "0");

  return (
    <div className="sticky top-0 z-30">
      <div className="border-b border-[var(--chrome)] bg-[rgba(7,8,26,0.85)] backdrop-blur-xl relative">
        <div className="px-8 lg:px-12 py-2 flex items-center justify-between gap-8 relative">
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2.5">
              <PulseDot color="green" />
              <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-glow-green">
                Hollow Vessel · Engaged
              </span>
            </div>
            <span className="hidden md:inline font-mono text-[9px] tracking-[0.25em] text-[var(--text-3)]">
              {codexVersion}
            </span>
          </div>

          <a
            href="/radio"
            data-testid="topbar-radio-pill"
            className="nx-radio-pill"
            aria-label="NextXus Radio — The Sovereign Pulse, live now"
          >
            <span className="nx-radio-pill-dot" aria-hidden="true" />
            <span className="font-mono text-[10px] uppercase tracking-[0.24em]" style={{ color: "#FFD700" }}>
              ▶ Radio
            </span>
          </a>

          <div className="hidden md:flex items-center gap-6">
            <EqBars count={14} color="cyan" />
            <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[var(--text-2)]">
              Truth Gate · 0.95
            </span>
            <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[var(--text-2)]">
              Ring · Six
            </span>
            <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-glow-magenta">
              Spark + Lens
            </span>
            <span className="font-mono text-[10px] tracking-[0.22em] text-[var(--text-3)] tabular-nums">
              UTC {hh}:{mm}:{ss}
            </span>
            <TokenBadge />
            <MemberBadge />
          </div>
        </div>
      </div>
    </div>
  );
}
